// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.latest-carousel-controls {
  display: flex;
  align-items: center;
  gap: 7px;
}

.latest-carousel-controls button {
  display: grid;
  width: 29px;
  height: 29px;
  place-items: center;
  border: 1px solid #ddd6fe;
  border-radius: 8px;
  background: #fff;
  color: #5b35f5;
  cursor: pointer;
}

.latest-carousel-controls button:hover {
  background: #f4f1ff;
}

.latest-carousel-controls span {
  color: #667085;
  font-size: 9px;
  font-weight: 800;
}

.latest-carousel-card {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin-top: 12px;
  border: 1px solid #cfc4ff;
  border-radius: 11px;
  background: linear-gradient(135deg, #fff, #fdfcff);
  cursor: pointer;
  transition: 0.2s;
}

.latest-carousel-card:hover {
  border-color: #8d78f7;
  box-shadow: 0 7px 20px rgba(91, 53, 245, 0.09);
}

.latest-carousel-card > section {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 8px;
  padding: 14px 18px;
}

.latest-carousel-card > section + section {
  border-left: 1px solid #ddd6fe;
}

.latest-detail {
  display: grid;
  grid-template-columns: 94px 7px minmax(0, 1fr);
  align-items: start;
  gap: 4px;
  min-width: 0;
}

.latest-detail span {
  color: #344054;
  font-size: 9px;
  font-weight: 700;
}

.latest-detail i {
  color: #667085;
  font-size: 9px;
  font-style: normal;
}

.latest-detail strong {
  overflow: hidden;
  color: #101828;
  font-size: 9px;
  font-weight: 700;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.latest-detail strong.primary {
  color: #5b35f5;
}

.latest-detail.feedback strong {
  color: #079455;
  white-space: normal;
}

.latest-detail em {
  width: fit-content;
  font-style: normal;
}

@media (max-width: 900px) {
  .latest-carousel-card {
    grid-template-columns: 1fr;
  }

  .latest-carousel-card > section + section {
    border-top: 1px solid #ddd6fe;
    border-left: 0;
  }
}

.latest-detail-link{min-width:0;overflow:hidden;border:0;padding:0;background:transparent;color:#4f46e5;font-size:9px;font-weight:800;text-align:left;text-overflow:ellipsis;white-space:nowrap;cursor:pointer}
.latest-detail-link:hover{text-decoration:underline}
.latest-submission-view,.submission-view-button{border:0;border-radius:8px;background:linear-gradient(135deg,#6d5dfc,#4f46e5);color:#fff;font-weight:800;cursor:pointer}
.latest-submission-view{align-self:flex-end;margin-top:auto;padding:8px 12px}
.submission-view-button{margin-left:auto;padding:6px 10px;font-size:10px}
.submission-candidate-link{display:block;border:0;padding:0;background:transparent;color:#4f46e5;font-size:14px;font-weight:800;text-align:left;cursor:pointer}
.submission-candidate-link:hover{text-decoration:underline}
.submission-candidate-link:disabled{color:#101828;cursor:default;text-decoration:none}
.employee-drilldown .submitted-candidate{cursor:default;border-color:#e9e4d8;background:linear-gradient(145deg,#fff,#fffdf8)}
.employee-drilldown .submitted-candidate:hover{border-color:#f0b35a;box-shadow:0 8px 22px rgba(180,110,20,.12)}
.employee-drilldown .submission-status.process-1{background:linear-gradient(135deg,#fff4d6,#ffe7ae);color:#9a5b00;border:1px solid #f5cf7b}
.employee-drilldown .submission-view-button:hover,.latest-submission-view:hover{filter:brightness(1.08);transform:translateY(-1px)}
/* Professional latest-submission carousel */
.latest-submissions {
  overflow: hidden;
  padding: 20px 22px;
  border-color: #e5e7eb;
  box-shadow: 0 10px 30px rgba(15,23,42,.06);
}

.latest-submissions .workforce-panel-heading {
  align-items: center;
  padding-bottom: 14px;
  border-bottom: 1px solid #eef2f6;
}

.latest-submissions .workforce-panel-heading h3 {
  color: #172033;
  font-size: 16px;
}

.latest-submissions .workforce-panel-heading h3 svg {
  color: #f97316;
}

.latest-carousel-controls {
  gap: 9px;
  padding: 4px;
  border: 1px solid #e5e7eb;
  border-radius: 11px;
  background: #f8fafc;
}

.latest-carousel-controls button {
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: 8px;
  color: #475569;
  box-shadow: 0 1px 2px rgba(15,23,42,.06);
  transition: transform .16s ease, color .16s ease, background .16s ease;
}

.latest-carousel-controls button:hover {
  background: #fff7ed;
  color: #ea580c;
  transform: translateY(-1px);
}

.latest-carousel-controls span {
  min-width: 38px;
  color: #475569;
  font-size: 10px;
  text-align: center;
}

.latest-carousel-card {
  position: relative;
  grid-template-columns: repeat(3,minmax(0,1fr));
  min-height: 230px;
  margin-top: 16px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(15,23,42,.055);
  cursor: default;
}

.latest-carousel-card::before {
  content: "";
  position: absolute;
  inset: 0 auto 0 0;
  width: 4px;
  background: linear-gradient(180deg,#f97316,#fb923c);
}

.latest-carousel-card:hover {
  border-color: #fdba74;
  box-shadow: 0 14px 34px rgba(154,52,18,.1);
  transform: translateY(-1px);
}

.latest-carousel-card > section {
  gap: 13px;
  padding: 24px 24px 22px;
}

.latest-carousel-card > section + section {
  border-left: 1px solid #edf1f5;
}

.latest-detail {
  grid-template-columns: 105px 8px minmax(0,1fr);
  align-items: center;
  gap: 7px;
  min-height: 22px;
}

.latest-detail span,
.latest-detail i {
  color: #64748b;
  font-size: 10px;
}

.latest-detail span {
  font-weight: 700;
  letter-spacing: .01em;
}

.latest-detail strong,
.latest-detail-link {
  color: #1e293b;
  font-size: 11px;
  line-height: 1.45;
}

.latest-detail-link {
  color: #4f46e5;
}

.latest-detail-link.primary {
  color: #4338ca;
  font-size: 12px;
}

.latest-submission-view {
  align-self: stretch;
  justify-content: center;
  min-height: 36px;
  margin-top: auto;
  background: #172033;
  letter-spacing: .01em;
}

.latest-submission-view:hover {
  background: #ea580c;
  filter: none;
}

@media (max-width: 1050px) {
  .latest-carousel-card {
    grid-template-columns: 1fr 1fr;
  }
  .latest-carousel-card > section:last-child {
    grid-column: 1 / -1;
    border-top: 1px solid #edf1f5;
    border-left: 0;
  }
}

@media (max-width: 700px) {
  .latest-submissions {
    padding: 16px;
  }
  .latest-submissions .workforce-panel-heading {
    align-items: flex-start;
    flex-direction: column;
  }
  .latest-carousel-card {
    grid-template-columns: 1fr;
  }
  .latest-carousel-card > section:last-child {
    grid-column: auto;
  }
  .latest-carousel-card > section + section {
    border-top: 1px solid #edf1f5;
    border-left: 0;
  }
  .latest-detail {
    grid-template-columns: 96px 6px minmax(0,1fr);
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Dashboard/latestSubmissionCarousel.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kDAAkD;EAClD,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8CAA8C;EAC9C,kBAAkB;EAClB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,6BAA6B;IAC7B,cAAc;EAChB;AACF;;AAEA,oBAAoB,WAAW,CAAC,eAAe,CAAC,QAAQ,CAAC,SAAS,CAAC,sBAAsB,CAAC,aAAa,CAAC,aAAa,CAAC,eAAe,CAAC,eAAe,CAAC,sBAAsB,CAAC,kBAAkB,CAAC,cAAc;AAC9M,0BAA0B,yBAAyB;AACnD,gDAAgD,QAAQ,CAAC,iBAAiB,CAAC,kDAAkD,CAAC,UAAU,CAAC,eAAe,CAAC,cAAc;AACvK,wBAAwB,mBAAmB,CAAC,eAAe,CAAC,gBAAgB;AAC5E,wBAAwB,gBAAgB,CAAC,gBAAgB,CAAC,cAAc;AACxE,2BAA2B,aAAa,CAAC,QAAQ,CAAC,SAAS,CAAC,sBAAsB,CAAC,aAAa,CAAC,cAAc,CAAC,eAAe,CAAC,eAAe,CAAC,cAAc;AAC9J,iCAAiC,yBAAyB;AAC1D,oCAAoC,aAAa,CAAC,cAAc,CAAC,oBAAoB;AACrF,yCAAyC,cAAc,CAAC,oBAAoB,CAAC,+CAA+C;AAC5H,+CAA+C,oBAAoB,CAAC,0CAA0C;AAC9G,iDAAiD,kDAAkD,CAAC,aAAa,CAAC,wBAAwB;AAC1I,gFAAgF,uBAAuB,CAAC,0BAA0B;AAClI,4CAA4C;AAC5C;EACE,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,QAAQ;EACR,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,wCAAwC;EACxC,sEAAsE;AACxE;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,8CAA8C;EAC9C,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;EACV,mDAAmD;AACrD;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8CAA8C;EAC9C,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE;IACE,8BAA8B;EAChC;EACA;IACE,mBAAmB;IACnB,6BAA6B;IAC7B,cAAc;EAChB;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,iBAAiB;EACnB;EACA;IACE,6BAA6B;IAC7B,cAAc;EAChB;EACA;IACE,6CAA6C;EAC/C;AACF","sourcesContent":[".latest-carousel-controls {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n}\n\n.latest-carousel-controls button {\n  display: grid;\n  width: 29px;\n  height: 29px;\n  place-items: center;\n  border: 1px solid #ddd6fe;\n  border-radius: 8px;\n  background: #fff;\n  color: #5b35f5;\n  cursor: pointer;\n}\n\n.latest-carousel-controls button:hover {\n  background: #f4f1ff;\n}\n\n.latest-carousel-controls span {\n  color: #667085;\n  font-size: 9px;\n  font-weight: 800;\n}\n\n.latest-carousel-card {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  margin-top: 12px;\n  border: 1px solid #cfc4ff;\n  border-radius: 11px;\n  background: linear-gradient(135deg, #fff, #fdfcff);\n  cursor: pointer;\n  transition: 0.2s;\n}\n\n.latest-carousel-card:hover {\n  border-color: #8d78f7;\n  box-shadow: 0 7px 20px rgba(91, 53, 245, 0.09);\n}\n\n.latest-carousel-card > section {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 8px;\n  padding: 14px 18px;\n}\n\n.latest-carousel-card > section + section {\n  border-left: 1px solid #ddd6fe;\n}\n\n.latest-detail {\n  display: grid;\n  grid-template-columns: 94px 7px minmax(0, 1fr);\n  align-items: start;\n  gap: 4px;\n  min-width: 0;\n}\n\n.latest-detail span {\n  color: #344054;\n  font-size: 9px;\n  font-weight: 700;\n}\n\n.latest-detail i {\n  color: #667085;\n  font-size: 9px;\n  font-style: normal;\n}\n\n.latest-detail strong {\n  overflow: hidden;\n  color: #101828;\n  font-size: 9px;\n  font-weight: 700;\n  line-height: 1.35;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.latest-detail strong.primary {\n  color: #5b35f5;\n}\n\n.latest-detail.feedback strong {\n  color: #079455;\n  white-space: normal;\n}\n\n.latest-detail em {\n  width: fit-content;\n  font-style: normal;\n}\n\n@media (max-width: 900px) {\n  .latest-carousel-card {\n    grid-template-columns: 1fr;\n  }\n\n  .latest-carousel-card > section + section {\n    border-top: 1px solid #ddd6fe;\n    border-left: 0;\n  }\n}\n\n.latest-detail-link{min-width:0;overflow:hidden;border:0;padding:0;background:transparent;color:#4f46e5;font-size:9px;font-weight:800;text-align:left;text-overflow:ellipsis;white-space:nowrap;cursor:pointer}\n.latest-detail-link:hover{text-decoration:underline}\n.latest-submission-view,.submission-view-button{border:0;border-radius:8px;background:linear-gradient(135deg,#6d5dfc,#4f46e5);color:#fff;font-weight:800;cursor:pointer}\n.latest-submission-view{align-self:flex-end;margin-top:auto;padding:8px 12px}\n.submission-view-button{margin-left:auto;padding:6px 10px;font-size:10px}\n.submission-candidate-link{display:block;border:0;padding:0;background:transparent;color:#4f46e5;font-size:14px;font-weight:800;text-align:left;cursor:pointer}\n.submission-candidate-link:hover{text-decoration:underline}\n.submission-candidate-link:disabled{color:#101828;cursor:default;text-decoration:none}\n.employee-drilldown .submitted-candidate{cursor:default;border-color:#e9e4d8;background:linear-gradient(145deg,#fff,#fffdf8)}\n.employee-drilldown .submitted-candidate:hover{border-color:#f0b35a;box-shadow:0 8px 22px rgba(180,110,20,.12)}\n.employee-drilldown .submission-status.process-1{background:linear-gradient(135deg,#fff4d6,#ffe7ae);color:#9a5b00;border:1px solid #f5cf7b}\n.employee-drilldown .submission-view-button:hover,.latest-submission-view:hover{filter:brightness(1.08);transform:translateY(-1px)}\n/* Professional latest-submission carousel */\n.latest-submissions {\n  overflow: hidden;\n  padding: 20px 22px;\n  border-color: #e5e7eb;\n  box-shadow: 0 10px 30px rgba(15,23,42,.06);\n}\n\n.latest-submissions .workforce-panel-heading {\n  align-items: center;\n  padding-bottom: 14px;\n  border-bottom: 1px solid #eef2f6;\n}\n\n.latest-submissions .workforce-panel-heading h3 {\n  color: #172033;\n  font-size: 16px;\n}\n\n.latest-submissions .workforce-panel-heading h3 svg {\n  color: #f97316;\n}\n\n.latest-carousel-controls {\n  gap: 9px;\n  padding: 4px;\n  border: 1px solid #e5e7eb;\n  border-radius: 11px;\n  background: #f8fafc;\n}\n\n.latest-carousel-controls button {\n  width: 32px;\n  height: 32px;\n  border: 0;\n  border-radius: 8px;\n  color: #475569;\n  box-shadow: 0 1px 2px rgba(15,23,42,.06);\n  transition: transform .16s ease, color .16s ease, background .16s ease;\n}\n\n.latest-carousel-controls button:hover {\n  background: #fff7ed;\n  color: #ea580c;\n  transform: translateY(-1px);\n}\n\n.latest-carousel-controls span {\n  min-width: 38px;\n  color: #475569;\n  font-size: 10px;\n  text-align: center;\n}\n\n.latest-carousel-card {\n  position: relative;\n  grid-template-columns: repeat(3,minmax(0,1fr));\n  min-height: 230px;\n  margin-top: 16px;\n  overflow: hidden;\n  border: 1px solid #e2e8f0;\n  border-radius: 16px;\n  background: #fff;\n  box-shadow: 0 8px 24px rgba(15,23,42,.055);\n  cursor: default;\n}\n\n.latest-carousel-card::before {\n  content: \"\";\n  position: absolute;\n  inset: 0 auto 0 0;\n  width: 4px;\n  background: linear-gradient(180deg,#f97316,#fb923c);\n}\n\n.latest-carousel-card:hover {\n  border-color: #fdba74;\n  box-shadow: 0 14px 34px rgba(154,52,18,.1);\n  transform: translateY(-1px);\n}\n\n.latest-carousel-card > section {\n  gap: 13px;\n  padding: 24px 24px 22px;\n}\n\n.latest-carousel-card > section + section {\n  border-left: 1px solid #edf1f5;\n}\n\n.latest-detail {\n  grid-template-columns: 105px 8px minmax(0,1fr);\n  align-items: center;\n  gap: 7px;\n  min-height: 22px;\n}\n\n.latest-detail span,\n.latest-detail i {\n  color: #64748b;\n  font-size: 10px;\n}\n\n.latest-detail span {\n  font-weight: 700;\n  letter-spacing: .01em;\n}\n\n.latest-detail strong,\n.latest-detail-link {\n  color: #1e293b;\n  font-size: 11px;\n  line-height: 1.45;\n}\n\n.latest-detail-link {\n  color: #4f46e5;\n}\n\n.latest-detail-link.primary {\n  color: #4338ca;\n  font-size: 12px;\n}\n\n.latest-submission-view {\n  align-self: stretch;\n  justify-content: center;\n  min-height: 36px;\n  margin-top: auto;\n  background: #172033;\n  letter-spacing: .01em;\n}\n\n.latest-submission-view:hover {\n  background: #ea580c;\n  filter: none;\n}\n\n@media (max-width: 1050px) {\n  .latest-carousel-card {\n    grid-template-columns: 1fr 1fr;\n  }\n  .latest-carousel-card > section:last-child {\n    grid-column: 1 / -1;\n    border-top: 1px solid #edf1f5;\n    border-left: 0;\n  }\n}\n\n@media (max-width: 700px) {\n  .latest-submissions {\n    padding: 16px;\n  }\n  .latest-submissions .workforce-panel-heading {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n  .latest-carousel-card {\n    grid-template-columns: 1fr;\n  }\n  .latest-carousel-card > section:last-child {\n    grid-column: auto;\n  }\n  .latest-carousel-card > section + section {\n    border-top: 1px solid #edf1f5;\n    border-left: 0;\n  }\n  .latest-detail {\n    grid-template-columns: 96px 6px minmax(0,1fr);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
